var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIconInfoldpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.34 57.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#2b2b2b;stroke-miterlimit:10;stroke-width:3px;}.cls-2{fill:#2b2b2b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dash_icon_infoldpi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.67,55.84A27.17,27.17,0,1,0,1.5,28.67,27.19,27.19,0,0,0,28.67,55.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.29,42.26a3.62,3.62,0,0,1-3.62,3.61h0a3.62,3.62,0,0,1-3.62-3.61V27.71a3.63,3.63,0,0,1,3.62-3.62h0a3.63,3.63,0,0,1,3.62,3.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 28.67,
    cy: 15.82,
    r: 4.43
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIconInfoldpi);
export default __webpack_public_path__ + "static/media/dash_icon_infoldpi.27fd8d9edbcde591c9b8841feccff74e.svg";
export { ForwardRef as ReactComponent };